let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fDoxa")).then(() => parcelRequire('3u0fx'));